import React, { useRef, useEffect, useState } from "react";
import { Box, Grid, IconButton, Skeleton, Typography } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { ArrowLeft, ArrowRight } from "iconsax-react";
import { useMediaQuery, useTheme } from "@mui/material";
export default function Caro3in1({ caro3in1Data, heading }) {
  const [isLoaded, setIsLoaded] = useState(false);
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  useEffect(() => {
    if (swiperRef.current && swiperRef.current.navigation) {
      setTimeout(() => {
        swiperRef.current.params.navigation.prevEl = prevRef.current;
        swiperRef.current.params.navigation.nextEl = nextRef.current;
        swiperRef.current.navigation.init();
        swiperRef.current.navigation.update();
      });
    }
  }, []);

  return (
    <Grid p={{ xs: 3, sm: 5 }}>
      <Typography
        fontFamily="KIAbodyLatinbasic_Bold"
        textAlign={{ xs: "left", sm: "center" }}
        pb={{ xs: 3, sm: 5 }}
        sx={{
          fontSize: "clamp(24px, 4vw, 34px)",
        }}
      >
        {heading.heading}
      </Typography>
      <Grid
        container
        justifyContent="center"
        sx={{ position: "relative", margin: "auto" }}
      >
        {/* Left Arrow */}
        <IconButton
          ref={prevRef}
          sx={{
            position: "absolute",
            left: "-10px",
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 10,
            color: "#FFF",
            padding: { xs: "10px", sm: "20px", md: "30px" },
            backgroundColor:
              activeIndex > 0 ? "rgba(0, 0, 0, 0.2)" : "transparent",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 1)",
            },
            display: activeIndex === 0 ? "none" : "flex",
          }}
        >
          <ArrowLeft size={25} />
        </IconButton>

        {/* Swiper Component */}
        <Swiper
          modules={[Navigation]}
          spaceBetween={35}
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1, // mobile
            },
            768: {
              slidesPerView: 3, // tablet and up
            },
          }}
          style={{ width: "100%", height: "70vh" }} // or adjust height responsively via Tailwind or CSS
        >
          {Array.isArray(caro3in1Data) && caro3in1Data?.map((item, index) => (
            <SwiperSlide key={index}>
              <Box
                position="relative"
                width="100%"
                sx={{
                  height: "35vh",
                }}
              >
                {!isLoaded && (
                  <Skeleton
                    animation="wave"
                    variant="rectangular"
                    width="100%"
                    height="100%"
                    sx={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                )}
                {/* Background Image */}

                <Box
                  component="img"
                  loading="eager"
                  decoding="async"
                  src={
                    isMobile && item?.mobileCover
                      ? item.mobileCover
                      : item.image
                  }
                  onLoad={() => setIsLoaded(true)}
                  alt="Meet our Global Superstar Image"
                  sx={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Box>
              <Typography
                variant="h6"
                fontFamily="KIAbodyLatinbasic_Bold"
                lineHeight={3}
                textAlign="center"
                sx={{
                  fontSize: "clamp(16px, 1.8vw, 18px)",
                }}
              >
                {item.title}
              </Typography>
              <Typography
                fontFamily="KIAbodyLatinbasic_Regular"
                textAlign="center"
                sx={{
                  fontSize: "clamp(16px, 1.8vw, 18px)",
                }}
              >
                {item.desc}
              </Typography>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Right Arrow */}
        <IconButton
          ref={nextRef}
          sx={{
            position: "absolute",
            right: "-10px",
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 10,
            color: "#FFF",
            padding: { xs: "10px", sm: "20px", md: "30px" },
            backgroundColor:
              activeIndex < caro3in1Data.length - 1
                ? "rgba(0, 0, 0, 0.2)"
                : "transparent",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 1)",
            },
            display: activeIndex === caro3in1Data.length - 1 ? "none" : "flex",
          }}
        >
          <ArrowRight size={25} />
        </IconButton>
      </Grid>
    </Grid>
  );
}
